// extracted by mini-css-extract-plugin
export var shimmerCondition = "styles-module__shimmerCondition___vaPmK";
export var shimmerContainer = "styles-module__shimmerContainer___vYV8r";
export var shimmerRiverContainer = "styles-module__shimmerRiverContainer___bm1w5";